export const french = [
  'bulbizarre',
  'herbizarre',
  'florizarre',
  'salamèche',
  'reptincel',
  'dracaufeu',
  'carapuce',
  'carabaffe',
  'tortank',
  'chenipan',
  'chrysacier',
  'papilusion',
  'aspicot',
  'coconfort',
  'dardargnan',
  'roucool',
  'roucoups',
  'roucarnage',
  'rattata',
  'rattatac',
  'piafabec',
  'rapasdepic',
  'abo',
  'arbok',
  'pikachu',
  'raichu',
  'sabelette',
  'sablaireau',
  'nidoran',
  'nidorina',
  'nidoqueen',
  'nidorino',
  'nidoking',
  'mélofée',
  'mélodelfe',
  'goupix',
  'feunard',
  'rondoudou',
  'nosferapti',
  'nosferalto',
  'mystherbe',
  'ortide',
  'rafflesia',
  'paras',
  'parasect',
  'mimitoss',
  'aéromite',
  'taupiqueur',
  'triopikeur',
  'miaouss',
  'persian',
  'psykokwak',
  'akwakwak',
  'férosinge',
  'colossinge',
  'caninos',
  'arcanin',
  'ptitard',
  'têtarte',
  'tartard',
  'abra',
  'kadabra',
  'alakazam',
  'machoc',
  'machopeur',
  'mackogneur',
  'chétiflor',
  'boustiflor',
  'empiflor',
  'tentacool',
  'tentacruel',
  'racaillou',
  'gravalanch',
  'grolem',
  'ponyta',
  'galopa',
  'ramoloss',
  'flagadoss',
  'magnéti',
  'magnéton',
  'canarticho',
  'doduo',
  'dodrio',
  'otaria',
  'lamantine',
  'tadmorv',
  'grotadmorv',
  'kokiyas',
  'crustabri',
  'fantominus',
  'spectrum',
  'ectoplasma',
  'onix',
  'soporifik',
  'hypnomade',
  'krabby',
  'krabboss',
  'voltorbe',
  'électrode',
  'noeunoeuf',
  'noadkoko',
  'osselait',
  'ossatueur',
  'kicklee',
  'tygnon',
  'excelanguge',
  'smogo',
  'smogogo',
  'rhinocorne',
  'rhinoféros',
  'leveinard',
  'saquedeneu',
  'kangourex',
  'hypotrempe',
  'hypocéan',
  'poissirène',
  'poissoroy',
  'stari',
  'staross',
  'm. mime',
  'insécateur',
  'lippoutou',
  'élektek',
  'magmar',
  'scarabrute',
  'tauros',
  'magicarpe',
  'léviator',
  'lokhlass',
  'métamorph',
  'évoli',
  'aquali',
  'voltali',
  'pyroli',
  'porygon',
  'amonita',
  'amonistar',
  'kabuto',
  'kabutops',
  'ptéra',
  'ronflex',
  'artikodin',
  'électhor',
  'sulfura',
  'minidraco',
  'draco',
  'dracolosse',
  'mewtwo',
  'mew',
  'germignon',
  'macronium',
  'méganium',
  'héricendre',
  'feurisson',
  'typhlosion',
  'kaiminus',
  'crocrodil',
  'aligatueur',
  'fouinette',
  'fouinar',
  'hoothoot',
  'noarfang',
  'coxy',
  'coxyclaque',
  'mimigal',
  'migalos',
  'nostenfer',
  'loupio',
  'lanturn',
  'pichu',
  'mélo',
  'toudoudou',
  'togepi',
  'togetic',
  'natu',
  'xatu',
  'wattouat',
  'lainergie',
  'pharamp',
  'joliflor',
  'marill',
  'azumarill',
  'simularbre',
  'tarpaud',
  'granivol',
  'floravol',
  'cotovol',
  'capumain',
  'tournegrin',
  'héliatronc',
  'yanma',
  'axoloto',
  'maraiste',
  'mentali',
  'noctali',
  'cornèbre',
  'roigada',
  'feuforêve',
  'zarbi',
  'qulbutoké',
  'girafarig',
  'pomdepik',
  'foretress',
  'insolourdo',
  'scorplane',
  'steelix',
  'snubbull',
  'granbull',
  'qwilfish',
  'cizayox',
  'caratroc',
  'scarhino',
  'farfuret',
  'teddiursa',
  'ursaring',
  'limagma',
  'volcaropod',
  'marcacrin',
  'cochignon',
  'corayon',
  'rémoraid',
  'octillery',
  'cadoizo',
  'démanta',
  'airmure',
  'malosse',
  'démolosse',
  'hyporoi',
  'phanpy',
  'donphan',
  'cerfrousse',
  'queulorior',
  'debugant',
  'kapoera',
  'lippouti',
  'élekid',
  'magby',
  'écrémeuh',
  'leuphorie',
  'raikou',
  'entei',
  'suicune',
  'embrylex',
  'ymphect',
  'tyranocif',
  'lugia',
  'ho-oh',
  'celebi',
  'arcko',
  'massko',
  'jungko',
  'poussifeu',
  'galifeu',
  'braségali',
  'gobou',
  'flobio',
  'laggron',
  'medhyèna',
  'grahyèna',
  'zigzaton',
  'linéon',
  'chenipotte',
  'armulys',
  'charmillon',
  'blindayls',
  'papinox',
  'nénupiot',
  'lombre',
  'ludicolo',
  'grainipiot',
  'pifeuil',
  'tengalice',
  'nirondelle',
  'hélédelle',
  'goélise',
  'bekipan',
  'tarsal',
  'kirlia',
  'gardevoir',
  'arakdo',
  'maskadra',
  'balignon',
  'chapignon',
  'parecool',
  'vigoroth',
  'monaflèmit',
  'ningale',
  'ninjask',
  'munja',
  'chuchmur',
  'ramboum',
  'brouhabam',
  'makuhita',
  'hariyama',
  'azurill',
  'tarinor',
  'skitty',
  'delcatty',
  'ténéfix',
  'mysdibule',
  'galekid',
  'galegon',
  'galeking',
  'méditikka',
  'charmina',
  'dynavolt',
  'élecsprint',
  'posipi',
  'négapi',
  'muciole',
  'lumivole',
  'rosélia',
  'gloupti',
  'avaltout',
  'carvanha',
  'sharpedo',
  'wailmer',
  'wailord',
  'chamallot',
  'camérupt',
  'chartor',
  'spoink',
  'groret',
  'spinda',
  'kraknoix',
  'vibraninf',
  'libégon',
  'cacnea',
  'cacturne',
  'tylton',
  'altaria',
  'mangriff',
  'séviper',
  'séléroc',
  'solaroc',
  'barloche',
  'barbicha',
  'écrapince',
  'colhomard',
  'balbuto',
  'kaorine',
  'lilia',
  'vacilys',
  'anorith',
  'armaldo',
  'barpau',
  'milobellus',
  'morphéo',
  'kecleon',
  'polichombr',
  'branette',
  'skelénox',
  'téraclope',
  'tropius',
  'éoko',
  'absol',
  'okéoké',
  'stalgamin',
  'oniglali',
  'obalie',
  'phogleur',
  'kaimorse',
  'coquiperl',
  'serpang',
  'rosabyss',
  'relicanth',
  'lovdisc',
  'draby',
  'drackhaus',
  'drattak',
  'terhal',
  'métang',
  'métalosse',
  'regirock',
  'regice',
  'registeel',
  'latias',
  'latios',
  'kyogre',
  'groudon',
  'rayquaza',
  'jirachi',
  'deoxys',
  'tortipouss',
  'boskara',
  'torterra',
  'ouisticram',
  'chimpenfeu',
  'simiabraz',
  'tiplouf',
  'prinplouf',
  'pingoléon',
  'étourmi',
  'étourvol',
  'étouraptor',
  'keunotor',
  'castorno',
  'crikzik',
  'mélokrik',
  'lixy',
  'luxio',
  'luxray',
  'rozbouton',
  'roserade',
  'kranidos',
  'charkos',
  'dinoclier',
  'bastiodon',
  'cheniti',
  'cheniselle',
  'papilord',
  'apitrini',
  'apireine',
  'pachirisu',
  'mustébouée',
  'mustéflott',
  'ceribou',
  'ceriflor',
  'sancoki',
  'tritosor',
  'capidextre',
  'baudrive',
  'grodrive',
  'laporeille',
  'lockpin',
  'magiréve',
  'corboss',
  'chaglam',
  'chaffreux',
  'korillon',
  'moufouette',
  'moufflair',
  'archéomire',
  'archéodong',
  'manzaï',
  'mime jr',
  'ptiravi',
  'pijako',
  'spiritomb',
  'griknot',
  'carmache',
  'carchacrok',
  'goinfrex',
  'riolu',
  'lucario',
  'hippopotas',
  'hippodocus',
  'rapion',
  'drascore',
  'cradopaud',
  'coatox',
  'vortente',
  'écayon',
  'luminéon',
  'babimanta',
  'blizzi',
  'blizzaroi',
  'dimoret',
  'magnézone',
  'coudlangue',
  'rhinastoc',
  'bouldeneu',
  'élekable',
  'maganon',
  'togekiss',
  'yanméga',
  'phyllali',
  'givrali',
  'scorvol',
  'mammochon',
  'porygon-z',
  'gallame',
  'tarinorme',
  'noctunoir',
  'momartik',
  'motisma',
  'créhelf',
  'créfollet',
  'créfadet',
  'dialga',
  'palkia',
  'heatran',
  'regigigas',
  'cresselia',
  'phione',
  'manaphy',
  'darkrai',
  'shaymin',
  'arceus',
  'victini',
  'vipélierre',
  'lianaja',
  'majaspic',
  'gruikui',
  'grotichon',
  'roitiflam',
  'moustillon',
  'mateloutre',
  'clamiral',
  'ratentif',
  'miradar',
  'ponchiot',
  'mastouffe',
  'chacripan',
  'léopardus',
  'feuillajou',
  'feuiloutan',
  'flamajou',
  'flamoutan',
  'flotajou',
  'flotoutan',
  'munna',
  'mushana',
  'poichigeon',
  'colombeau',
  'déflaisan',
  'zébribon',
  'zéblitz',
  'nodulithe',
  'géolithe',
  'gigalithe',
  'chovsourir',
  'rhinolove',
  'rototaupe',
  'minotaupe',
  'nanméouïe',
  'charpenti',
  'ouvrifier',
  'bétochef',
  'tritonde',
  'batracné',
  'crapustule',
  'judokrak',
  'karaclée',
  'larveyette',
  'couverdure',
  'manternel',
  'venipatte',
  'scobolide',
  'brutapode',
  'doudouvet',
  'farfaduvet',
  'chlorobule',
  'fragilady',
  'bargantua',
  'mascaïman',
  'escroco',
  'crocorible',
  'darumarond',
  'darumacho',
  'maracachi',
  'crabicoque',
  'crabaraque',
  'baggiguane',
  'baggaïd',
  'cryptéro',
  'tutafeh',
  'tutankafer',
  'carapagos',
  'mégapagos',
  'arkéapti',
  'aéroptéryx',
  'miamiasme',
  'miasmax',
  'zorua',
  'zoroark',
  'chinchidou',
  'pashmilla',
  'scrutella',
  'mesmérella',
  'sidérella',
  'nucléos',
  'méios',
  'symbios',
  'couaneton',
  'lakmécygne',
  'sorbébé',
  'sorboul',
  'sorbouboul',
  'vivaldaim',
  'haydaim',
  'emolga',
  'carabing',
  'lançargot',
  'trompignon',
  'gaulet',
  'viskuse',
  'moyade',
  'mamanbo',
  'statitik',
  'mygavolt',
  'grindur',
  'noacier',
  'tic',
  'clic',
  'cliticlic',
  'anchwatt',
  'lampéroie',
  'ohmassacre',
  'lewsor',
  'neitram',
  'funécire',
  'mélancolux',
  'lugulabre',
  'coupenotte',
  'incisache',
  'tranchodon',
  'polarhume',
  'polagriffe',
  'hexagel',
  'escargaume',
  'limaspeed',
  'limonde',
  'kungfouine',
  'shaofouine',
  'drakkarmin',
  'gringolem',
  'golemastoc',
  'scalpion',
  'scalproie',
  'frison',
  'furaiglon',
  'gueriaigle',
  'vostourno',
  'vaututrice',
  'aflamanoir',
  'fermite',
  'solochi',
  'diamat',
  'trioxhydre',
  'pyronille',
  'pyrax',
  'cobaltium',
  'terrakium',
  'viridium',
  'boréas',
  'fulguris',
  'reshiram',
  'zekrom',
  'démétéros',
  'kyurem',
  'keldeo',
  'meloetta',
  'genesect',
  'marisson',
  'boguérisse',
  'blindépique',
  'feunnec',
  'roussil',
  'goupelin',
  'grenousse',
  'croâporal',
  'amphinobi',
  'sapereau',
  'excavarenne',
  'passerouge',
  'braisillon',
  'flambusard',
  'lépidonille',
  'pérégrain',
  'prismillon',
  'hélionceau',
  'némélios',
  'flabébé',
  'floette',
  'florges',
  'cabriolaine',
  'chevroum',
  'pandespiègle',
  'pandarbare',
  'couafarel',
  'psystigri',
  'mistigrix',
  'monorpale',
  'dimoclès',
  'exagide',
  'fluvetin',
  'cocotine',
  'sucroquin',
  'cupcanaille',
  'sepiatop',
  'sepiatroce',
  'opermine',
  'golgopathe',
  'venalgue',
  'kravarech',
  'flingouste',
  'gamblast',
  'galvaran',
  'iguolta',
  'ptyranidur',
  'rexillius',
  'amagara',
  'dragmara',
  'nymphali',
  'brutalibré',
  'dedenne',
  'strassie',
  'mucuscule',
  'colimucus',
  'muplodocus',
  'trousselin',
  'brocélôme',
  'desséliande',
  'pitrouille',
  'banshitrouye',
  'grelaçon',
  'séracrawl',
  'sonistrelle',
  'bruyverne',
  'xerneas',
  'yveltal',
  'zygarde',
  'diancie',
  'hoopa',
  'volcanion',
  'brindibou',
  'efflèche',
  'archéduc',
  'flamiaou',
  'matoufeu',
  'félinferno',
  'otaquin',
  'otarlette',
  'oratoria',
  'picassaut',
  'piclairon',
  'bazoucan',
  'manglouton',
  'argouste',
  'larvibule',
  'chrysapile',
  'lucanon',
  'crabagarre',
  'crabominable',
  'plumeline',
  'bombydou',
  'rubombelle',
  'rocabot',
  'lougaroc',
  'froussardine',
  'vorastérie',
  'prédastérie',
  'tiboudet',
  'bourrinos',
  'araqua',
  'tarenbulle',
  'mimantis',
  'floramantis',
  'spododo',
  'lampignon',
  'tritox',
  'malamandre',
  'nounourson',
  'chelours',
  'croquine',
  'candine',
  'sucreine',
  'guérilande',
  'gouroutan',
  'quartermac',
  'sovkipou',
  'sarmuraï',
  'bacabouh',
  'trépassable',
  'concombaffe',
  'type:0',
  'silvallié',
  'météno',
  'dodoala',
  'boumata',
  'togedemaru',
  'mimiqui',
  'denticrisse',
  'draïeul',
  'sinistrail',
  'bébécaille',
  'écaïd',
  'ékaïser',
  'tokorico',
  'tokopiyon',
  'tokotoro',
  'tokopisco',
  'cosmog',
  'cosmovum',
  'solgaleo',
  'lunala',
  'zéroïd',
  'mouscoto',
  'cancrelove',
  'câblifère',
  'bamboiselle',
  'katagami',
  'engloutyran',
  'necrozma',
  'magearna',
  'marshadow',
  'vémini',
  'mandrillon',
  'ama-ama',
  'pierroteknik',
  'zeraora',
  'meltan',
  'melmetal',
  'ouistempo',
  'badabouin',
  'gorythmic',
  'flambino',
  'lapyro',
  'pyrobut',
  'larméléon',
  'arrozard',
  'lézargus',
  'rongourmand',
  'rongrigou',
  'minisange',
  'bleuseille',
  'corvaillus',
  'larvadar',
  'coléodôme',
  'astronelle',
  'goupilou',
  'roublenard',
  'tournicoton',
  'blancoton',
  'moumouton',
  'moumouflon',
  'khélocrok',
  'torgamord',
  'voltoutou',
  'fulgudog',
  'charbi',
  'wagomine',
  'monthracite',
  'verpom',
  'pomdrapi',
  'dratatin',
  'dunaja',
  'dunaconda',
  'nigosier',
  'embrochet',
  'hastacuda',
  'toxizap',
  'salarsen',
  'grillepattes',
  'scolocendre',
  'poulpaf',
  'krakos',
  'théffroi',
  'polthégeist',
  'bibichut',
  'chapotus',
  'sorcilence',
  'grimalin',
  'fourbelin',
  'angoliath',
  'ixon',
  'berserkatt',
  'corayôme',
  'palarticho',
  'm. glaquette',
  'tutétékri',
  'crémy',
  'charmilly',
  'hexadron',
  'wattapik',
  'frissonille',
  'beldeneige',
  'dolman',
  'bekaglaçon',
  'wimessir',
  'morpeko',
  'charibari',
  'pachyradjah',
  'galvagon',
  'galvagla',
  'hydragon',
  'hydragla',
  'duralugon',
  'fantyrm',
  'dispareptil',
  'lanssorien',
  'zacian',
  'zamazenta',
  'éthernatos',
  'wushours',
  'shifours',
  'zarude',
  'regieleki',
  'regidrago',
  'blizzeval',
  'spectreval',
  'sylveroy',
  'cerbyllin',
  'hachécateur',
  'ursaking',
  'paragruel',
  'farfurex',
  'qwilpik',
  'amovénus',
  'poussacha',
  'matourgeon',
  'miascarade',
  'chochodile',
  'crocogril',
  'flâmigator',
  'coiffeton',
  'canarbello',
  'palmaval',
  'gourmelet',
  'fragroin',
  'tissenboule',
  'filentrappe',
  'lilliterelle',
  'gambex',
  'pohm',
  'pohmotte',
  'pohmarmotte',
  'compagnol',
  'famignol',
  'pâtachiot',
  'briochien',
  'olivini',
  'olivado',
  'arboliva',
  'tapatoès',
  'selutin',
  'amassel',
  'gigansel',
  'charbambin',
  'carmadura',
  'malvalame',
  'têtampoule',
  'ampibidou',
  'zapétrel',
  'fulgulairo',
  'grondogue',
  'dogrino',
  'gribouraigne',
  'tag-tag',
  'virovent',
  'virevorreur',
  'terracool',
  'terracruel',
  'craparoi',
  'pimito',
  'scovilain',
  'léboulérou',
  'bérasca',
  'flotillon',
  'cléopsytra',
  'forgerette',
  'forgella',
  'forgelina',
  'taupikeau',
  'triopikeau',
  'lestombaile',
  'dofin',
  'superdofin',
  'vrombi',
  'vrombotor',
  'motorizard',
  'ferdeter',
  'germéclat',
  'floréclat',
  'toutombe',
  'tomberro',
  'flamenroule',
  'piétacé',
  'balbaléze',
  'délestin',
  'oyacata',
  'nigirigon',
  'courrousinge',
  'terraiste',
  'farigiraf',
  'deusolourdo',
  'scalpereur',
  'fort-ivoire',
  'hurle-queue',
  'fongus-furie',
  'flotte-mèche',
  'rampe-ailes',
  'pelage-sablé',
  'roue-de-fer',
  'hotte-de-fer',
  'paume-de-fer',
  'têtes-de-fer',
  'mite-de-fer',
  'épine-de-fer',
  'frigodo',
  'cryodo',
  'glaivodo',
  'mordudor',
  'gromago',
  'chongjian',
  'baojian',
  'dinglu',
  'yuyu',
  'rugit-lune',
  'garde-de-fer',
  'koraidon',
  'miraidon',
];
